export const defaultDayTimePreferencesInitialValues = {
   MONDAY: [],
   TUESDAY: [],
   WEDNESDAY: [],
   THURSDAY: [],
   FRIDAY: [],
   SATURDAY: [],
   SUNDAY: [],
};
